import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Button,
  Chip,
} from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
const ProductsGrid = ({
  searchResults,
  filteredProducts,
  IMAGE_BASE_URL,
  placeholderImage,
  onAddToCart,
  isMobile,
}) => {
  const renderProductCard = (product) => (
    <Card
      sx={{
        borderRadius: { xs: 3, md: 4 },
        boxShadow: "0 3px 16px rgba(255, 61, 61, 0.08)",
        border: "1.5px solid #f5f5f5",
        bgcolor: "#fff",
        transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
        "&:hover": {
          transform: { xs: "scale(1.02)", sm: "translateY(-6px) scale(1.02)" },
          boxShadow: "0 8px 28px rgba(255, 61, 61, 0.14)",
          borderColor: "#ffe0b2",
        },
        display: "flex",
        flexDirection: "column",
        height: "100%",
        py: { xs: 1, sm: 1.25, md: 1.75 },
        px: { xs: 0.875, sm: 1, md: 1.25 },
      }}
    >
      <CardMedia
        component="img"
        image={product.image ? `${IMAGE_BASE_URL}${product.image}` : placeholderImage}
        alt={product.name}
        sx={{
          width: "100%",
          aspectRatio: "1",
          objectFit: "cover",
          borderRadius: "50%",
          mb: { xs: 0.875, sm: 1.25, md: 1.5 },
          border: { xs: "2.5px solid #fffbe6", md: "3px solid #fffbe6" },
          boxShadow: "0 2px 10px rgba(255, 179, 0, 0.15)",
        }}
      />
      <CardContent sx={{ 
        textAlign: "center", 
        p: 0, 
        px: { xs: 0.5, sm: 0.75 },
        flex: 1,
        display: "flex",
        flexDirection: "column",
      }}>
        <Typography
          sx={{ 
            fontWeight: 800, 
            color: "#222", 
            fontSize: { xs: 13, sm: 14.5, md: 18 }, 
            mb: { xs: 0.375, sm: 0.5, md: 0.75 },
            lineHeight: 1.3,
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
          }}
        >
          {product.name}
        </Typography>
        <Box sx={{ 
          color: "#ffb300", 
          mb: { xs: 0.375, sm: 0.5, md: 0.75 },
          fontSize: { xs: 11, sm: 12.5, md: 14 },
        }}>
          {"★★★★★"}
        </Box>
        <Typography
          color="text.secondary"
          sx={{ 
            mb: { xs: 0.875, sm: 1.25, md: 1.5 }, 
            fontSize: { xs: 10.5, sm: 12, md: 14 }, 
            flex: 1,
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            lineHeight: 1.4,
          }}
        >
          {product.description}
        </Typography>
        <Typography
          sx={{ 
            color: "#ff3d3d", 
            fontWeight: 900, 
            fontSize: { xs: 14.5, sm: 16, md: 18 },
            mb: { xs: 0.75, sm: 1 },
          }}
        >
          {product.price} ج.م
        </Typography>
      </CardContent>
      <CardActions sx={{ p: 0, justifyContent: "center" }}>
        <Button
          variant="contained"
          fullWidth
          sx={{
            bgcolor: "#ffb300",
            color: "#fff",
            fontWeight: 800,
            borderRadius: { xs: 2, md: 2.5 },
            py: { xs: 0.625, sm: 0.875, md: 1 },
            fontSize: { xs: 11.5, sm: 13, md: 14.5 },
            boxShadow: "0 2px 8px rgba(255, 179, 0, 0.25)",
            transition: "all 0.2s",
            "&:hover": { 
              bgcolor: "#ff3d3d",
              transform: "translateY(-2px)",
              boxShadow: "0 4px 12px rgba(255, 61, 61, 0.3)",
            },
          }}
          onClick={() => onAddToCart(product)}
          startIcon={
            <ShoppingCartIcon sx={{ fontSize: { xs: 15, sm: 17, md: 20 } }} />
          }
        >
          {isMobile ? "اطلب" : "اطلب الآن"}
        </Button>
      </CardActions>
    </Card>
  );

  return (
    <>
      {searchResults ? (
        // عرض نتائج البحث
        searchResults.map((result) => (
          <Box key={result.category.id} sx={{ mb: { xs: 2.5, sm: 3.5, md: 4.5 } }}>
            <Typography sx={{
              px: { xs: 1.25, sm: 2.5, md: 6 },
              mb: { xs: 1.25, sm: 1.75 },
              fontWeight: 800,
              fontSize: { xs: 16, sm: 18, md: 22 },
              color: "#ff3d3d",
              borderBottom: "2px solid #ffe0b2",
              pb: 0.75,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}>
              <span>{result.category.name}</span>
              <Chip 
                label={result.products.length} 
                size="small"
                sx={{ 
                  bgcolor: "#fffbe6",
                  color: "#ff3d3d",
                  fontWeight: 700,
                  fontSize: { xs: 11, sm: 12 },
                }}
              />
            </Typography>
            <Grid 
              container 
              spacing={{ xs: 1.25, sm: 2, md: 3 }} 
              px={{ xs: 1.25, sm: 2.5, md: 6 }}
            >
              {result.products.map((product) => (
                <Grid item xs={6} sm={6} md={4} lg={3} key={product.id}>
                  {renderProductCard(product)}
                </Grid>
              ))}
            </Grid>
          </Box>
        ))
      ) : (
        // عرض المنتجات العادية
        <Grid 
          container 
          spacing={{ xs: 1.25, sm: 2, md: 3 }} 
          px={{ xs: 1.25, sm: 2.5, md: 6 }}
        >
          {filteredProducts.map((product) => (
            <Grid item xs={6} sm={6} md={4} lg={3} key={product.id}>
              {renderProductCard(product)}
            </Grid>
          ))}
        </Grid>
      )}
    </>
  );
};

export default ProductsGrid;
